export const ANALYTICS_VISUAL_TYPES = {
  FUNNEL: 'funnel',
  MATRIX: 'matrix',
  METRIC_ROWS: 'metric_rows',
  OFFER_COLUMNS: 'offer_columns',
  GEO_TRAFFIC: 'geo_traffic',
  TIME_SERIES: 'time_series',
  KPI: 'kpi',
  DISTRIBUTION: 'distribution',
  PROGRESS: 'progress',
  TABLE: 'table',
  COMPARISON: 'comparison',
  RADAR: 'radar'
};

export const ANALYTICS_SIZE_OPTIONS = ['compact', 'medium', 'three-quarter', 'large'];

export const ANALYTICS_DATA_STATUS = {
  READY: 'ready',
  EMPTY: 'empty',
  UNSUPPORTED: 'unsupported',
  MISSING_SOURCE: 'missing_source'
};

export const ANALYTICS_DATA_LAYERS = {
  NATIVE: 'native',
  CONNECTED: 'connected',
  HYBRID: 'hybrid'
};

export const ANALYTICS_METRIC_SEMANTICS = {
  COUNT: 'count',
  RATE: 'rate',
  DURATION: 'duration',
  DISTRIBUTION: 'distribution',
  COMPOSITION: 'composition',
  RELATIONSHIP: 'relationship',
  GOAL: 'goal',
  GEO: 'geo'
};

export const ANALYTICS_TIME_BEHAVIORS = {
  NONE: 'none',
  ROLLING_WINDOW: 'rolling_window',
  PERIOD_TREND: 'period_trend',
  COHORT_TREND: 'cohort_trend',
  STEP_SEQUENCE: 'step_sequence'
};

export const ANALYTICS_SUMMARY_BEHAVIORS = {
  WINDOW_TOTAL: 'window_total',
  CURRENT_RATE: 'current_rate',
  AVG_DURATION: 'avg_duration',
  SHARE_OF_TOTAL: 'share_of_total',
  GOAL_PROGRESS: 'goal_progress',
  DISTRIBUTION_OVERVIEW: 'distribution_overview',
  GEO_ROLLUP: 'geo_rollup'
};

export const ANALYTICS_DELTA_BEHAVIORS = {
  NONE: 'none',
  MOM: 'mom',
  QOQ: 'qoq'
};

export const createVisualModel = ({
  id,
  type,
  size = 'medium',
  datasetShape = '',
  dataset = null,
  datasets = {},
  activeGraph = '',
  availableGraphs = [],
  variant = 'contextual',
  dataStatus = ANALYTICS_DATA_STATUS.READY,
  title = '',
  annotations = [],
  meta = {},
  options = {}
}) => ({
  id,
  type,
  size,
  datasetShape,
  dataset,
  datasets,
  activeGraph,
  availableGraphs,
  variant,
  dataStatus,
  title,
  annotations,
  meta,
  options
});

export const createAnalyticsLibraryEntry = ({
  id,
  label,
  visualType,
  category = '',
  datasetShapes = [],
  supportedGraphs = [],
  defaultGraph = '',
  defaultSize = 'medium',
  defaultVariant = 'contextual',
  dataShape = null,
  dataRequirements = {},
  requiredProducts = [],
  dataSemantics = {},
  graphConfig = {},
  dataLayer = ANALYTICS_DATA_LAYERS.NATIVE,
  supportedFilters = [],
  supportsGroupBy = false,
  defaultGroupBy = '',
  groupByOptions = []
}) => ({
  id,
  label,
  visualType,
  category,
  datasetShapes: datasetShapes.length ? datasetShapes : dataShape ? [dataShape] : [],
  supportedGraphs,
  defaultGraph,
  defaultSize,
  defaultVariant,
  dataRequirements: Object.keys(dataRequirements).length ? dataRequirements : dataShape || {},
  requiredProducts,
  dataSemantics,
  graphConfig,
  dataLayer,
  supportedFilters,
  supportsGroupBy,
  defaultGroupBy,
  groupByOptions
});

export const createAnalyticsLibraryCategory = ({ id, label, widgets = [] }) => ({
  id,
  label,
  widgets
});

export const createAnalyticsSectionLibrary = ({ section, categories = [] }) => ({
  section,
  categories,
  widgets: categories.flatMap((category) => category.widgets)
});
